export interface Livestream {
  id: string;
  title: string;
  youtubeIds: string[];
}

export type StreamPoolItem = {
  title: string;
  youtubeId: string;
};

/**
 * Extra streams users can cycle through in any dock cell.
 * Add to this list and the UI "Swap" button will include them automatically.
 */
export const STREAM_POOL: StreamPoolItem[] = [
  { title: 'Donyo Lodge — Kenya', youtubeId: 'XsOU8JnEpNM' },
  { title: 'Utopia reef cam', youtubeId: 'jzx_n25g3kA' },
  { title: 'Wild Africa Live', youtubeId: 'qpukdDslCjk' },
  { title: 'Bison watering hole', youtubeId: 'g6wxYiESkE4' },
  { title: 'Camelthorn waterhole', youtubeId: 'mk02pEy3FdA' },
  { title: 'Big Bear eagles', youtubeId: 'B4-L2nfGcuE' },
  { title: 'Lentorre, Kenya', youtubeId: 'bEmFpjwMOvs' },
  { title: 'Woodland stream', youtubeId: '8kEzFZvtLzM' },
  { title: 'Moody Gardens penguins', youtubeId: 'HHp4rjhJsWI' },
  { title: 'Wolf Center north', youtubeId: '5e4lsEe4Vew' },
  { title: 'Tawny owl nest', youtubeId: 'U-rvoF1tLoU' },
  { title: 'Great gray owl nest', youtubeId: 'Wq7JWmpzKyM' },
  { title: 'Mount Rainier wildflowers', youtubeId: 'nslC27nST-Y' },
  { title: 'Lake Fairlee loons', youtubeId: 'mFSGKt0sV60' },
  { title: 'Mendenhall Glacier', youtubeId: 'jJI5w_RVGtQ' },
  { title: 'Wahoo Bay underwater', youtubeId: 'oBTGY6Ax870' },
];

export const LIVESTREAMS: Livestream[] = [
  {
    id: 'pandas',
    title: 'Pandas',
    youtubeIds: ['ydYDqZQpim8', 'F0GOOP82094', '3szkFHfr6sA'],
  },
  { id: 'otters', title: 'Otters', youtubeIds: ['NqOmHpwMUxs'] },
  { id: 'nature-reserve', title: 'Nature reserve', youtubeIds: ['2360fnKZcIQ'] },
  { id: 'jelly-cam', title: 'Live cam', youtubeIds: ['DHUnz4dyb54'] },
];
